export const guideData = [
  {
    name: '自動発注',
    guideType: '1',
    marginLeft: '0px'
  },
  {
    name: '自動在庫引当機能',
    guideType: '2',
    marginLeft: '0px'
  },
  {
    name: '複数倉庫出荷設定',
    guideType: '3',
    marginLeft: '-48px'
  },
  {
    name: '注文履歴',
    guideType: '4',
    marginLeft: '-128px'
  },
  {
    name: '在庫管理',
    guideType: '5',
    marginLeft: '-128px'
  }
]
